import { render, staticRenderFns } from "./JCameraCapture.vue?vue&type=template&id=0fb2a9a6"
import script from "./JCameraCapture.vue?vue&type=script&lang=js"
export * from "./JCameraCapture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports